import React from 'react';

import Section from 'react-scale/components/elements/section';

import { mq } from 'react-scale/components/website/big/Themes';

const ImagesGrid = ({ images }) => (
  <Section container={false}>
    <div>
      {images &&
        images.map(image => (
          <figure key={image.alt}>
            <img src={image.src} alt={image.alt} />
          </figure>
        ))}
      <style jsx>{`
        div {
          display: grid;
          grid-template-columns: 1fr;
          grid-gap: 4rem;
          padding: 0 4rem;
        }
        @media (min-width: ${mq.md}) {
          div {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        figure {
          margin: 0;
        }
      `}</style>
    </div>
  </Section>
);

export default ImagesGrid;
